/* firmanumre-kurv.js
   Kurvens adfaerd. Ren vanilla, ingen jQuery, ingen afhaengigheder.

   To ting:

   1. KORTET. Paa telefon er skuffen et kort der glider op nedefra. Grebet og
      hovedet kan traekkes: ned lukker, op folder ud til fuld hoejde. Traekket
      koerer paa transform, saa det ikke tvinger layout om.

   2. FRISTEN. Teksten lover, at valgene kun gemmes i 20 minutter, og derfor
      SKAL kurven faktisk toemmes efter 20 minutter. En nedtaelling uden en reel
      frist bag er aggressiv handelspraksis efter markedsfoeringslovens bilag 1
      nr. 7. Naar uret naar nul, kalder scriptet /cart/clear.js.

      Fristen ligger i localStorage, ikke i DOM'en. Skuffens indhold gengives
      forfra ved hver aendring af kurven, saa et ur der levede i markup'en ville
      starte forfra hver gang nogen aendrede antal. Fristen saettes foerste gang
      kurven bliver ikke-tom, og ryddes naar kurven er tom igen.
*/
(function () {
  'use strict';

  var NOEGLE = 'fn_kurv_frist';
  var MINUTTER = 20;
  var ur = null;

  /* ---------- fristen ---------- */

  function laesFrist() {
    try {
      var v = window.localStorage.getItem(NOEGLE);
      return v ? parseInt(v, 10) : null;
    } catch (e) { return null; }
  }

  function skrivFrist(t) {
    try {
      if (t === null) window.localStorage.removeItem(NOEGLE);
      else window.localStorage.setItem(NOEGLE, String(t));
    } catch (e) { /* privat vindue: fristen kan ikke huskes, uret vises ikke */ }
  }

  /* Kurvens indhold laeses af SERVEREN, ikke af skuffens markup.
     Foerste udgave talte `#CartDrawer .ajaxcart__product`, men skuffen er ikke
     tegnet, foer den har vaeret aabnet. Udloebet blev derfor aldrig opdaget paa
     en side hvor kurven ikke var aabnet. Maalt: kurven havde 1 vare paa
     serveren, mens DOM'en havde 0, og /cart/clear.js blev aldrig kaldt. */
  var antal = null;          // sidst kendte antal varer, null indtil foerste svar
  /* Hvilke VARIANTER der ligger i kurven, ikke bare hvor mange varer.
     Et guldnummer findes kun én gang og har praecis én variant, saa et nummer
     der allerede ligger i kurven, maa ikke kunne laegges i igen. Knapperne i
     firmanumre-kort.js laeser dette via window.fnKurv. */
  var iKurven = {};
  var henter = false;
  var sidstSvar = 0;
  var planlagt = null;

  /* Temaet gengiver kurven flere gange for én aendring - maalt 11 kald til
     /cart.js for én tilfoejelse. Der hentes derfor hoejst hvert 300. ms, og
     bliver et kald bremset, planlaegges ét til sidst, saa den ENDELIGE
     tilstand altid bliver laest. Uden det ville en hurtig aendring kunne
     ende med at kurven stod med et forkert antal. */
  function hentKurv() {
    if (henter) return Promise.resolve(antal);
    var siden = Date.now() - sidstSvar;
    if (siden < 300) {
      if (!planlagt) {
        planlagt = window.setTimeout(function () { planlagt = null; synkroniserFrist(); }, 300 - siden);
      }
      return Promise.resolve(antal);
    }
    henter = true;
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (k) {
        // Fjern tidligere valg af viderestilling, som er udgået af kurven.
        var attributter = k.attributes || {};
        if (!attributter['Viderestilling ønskes'] && !attributter['Viderestil opkald til']) return k;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: {
            'Viderestilling ønskes': '',
            'Viderestil opkald til': ''
          } })
        }).then(function (r) {
          if (!r.ok) throw new Error('Kunne ikke rydde tidligere valg af viderestilling');
          return r.json();
        });
      })
      .then(function (k) {
        antal = k.item_count; sidstSvar = Date.now(); henter = false;
        var nyt = {}, varer = k.items || [], i;
        for (i = 0; i < varer.length; i++) nyt[String(varer[i].variant_id)] = true;
        var foer = Object.keys(iKurven).sort().join(','), efter = Object.keys(nyt).sort().join(',');
        iKurven = nyt;
        opdaterTal(antal);
        /* Kun naar sammensaetningen faktisk aendrer sig. Temaet gengiver kurven
           mange gange for én aendring, og en haendelse pr. gengivelse ville
           saette alle koebsknapper paa siden om igen og igen. */
        if (foer !== efter) window.dispatchEvent(new CustomEvent('fn:kurv'));
        return antal;
      })
      ['catch'](function () { sidstSvar = Date.now(); henter = false; return antal; });
  }

  function toTal(n) { return (n < 10 ? '0' : '') + n; }

  function toemKurven() {
    skrivFrist(null);
    /* Flaget overlever genindlaesningen, saa beskeden kan vises paa den tomme
       kurv. Uden det ville kunden bare finde en tom kurv uden forklaring. */
    try { window.sessionStorage.setItem('fn_kurv_udloebet', '1'); } catch (e) {}
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin'
    }).then(function () { window.location.reload(); })
      ['catch'](function () { window.location.reload(); });
  }

  function tegnFrist() {
    var boks = document.querySelector('#CartDrawer .fnkv-frist');
    var frist = laesFrist();

    /* Udloebet afgoeres FOER der tegnes, og uafhaengigt af om skuffen findes.
       Ellers ville loeftet i teksten kun holde, naar kurven var aabnet. */
    if (frist && Date.now() >= frist) {
      if (antal === null) { hentKurv().then(function () { if (antal > 0) toemKurven(); else skrivFrist(null); }); return; }
      if (antal > 0) {
        if (boks) {
          boks.classList.add('fnkv-frist--udloebet');
          var t = boks.querySelector('.fnkv-frist-tekst');
          var u = boks.querySelector('.fnkv-frist-ur');
          if (t) t.textContent = 'Tiden er udløbet.';
          if (u) u.textContent = '';
        }
        toemKurven();
      } else {
        skrivFrist(null);
      }
      return;
    }

    if (!boks) return;
    if (!frist || antal === 0) { boks.hidden = true; return; }
    boks.hidden = false;
    var urEl = boks.querySelector('.fnkv-frist-ur');
    var s = Math.floor((frist - Date.now()) / 1000);
    if (urEl) urEl.textContent = toTal(Math.floor(s / 60)) + ':' + toTal(s % 60);
  }

  function startUr() {
    if (ur) window.clearInterval(ur);
    ur = window.setInterval(tegnFrist, 1000);
    tegnFrist();
  }

  function synkroniserFrist() {
    return hentKurv().then(function (n) {
      if (n === null) { startUr(); return; }   // bremset kald: der kommer et rigtigt bagefter
      if (n === 0) skrivFrist(null);
      else if (n > 0 && !laesFrist()) skrivFrist(Date.now() + MINUTTER * 60 * 1000);
      startUr();
    });
  }

  /* ---------- sidelaasen: baggrunden maa ikke rulle bag kortet ---------- */

  /* `overscroll-behavior: contain` paa den rullende beholder er ikke nok.
     Den stopper kaedet rulning i Chrome, men den daekker kun det tilfaelde,
     hvor beholderen FAKTISK kan rulle og naar sin ende. Med faa numre i
     kurven kan `.drawer__inner` slet ikke rulle, og saa gaar hele bevaegelsen
     videre til dokumentet. iOS Safari lader desuden siden gummi-rulle bag
     ved, uanset `contain`. Derfor laases siden, saa laenge skuffen er aaben.

     To laase, fordi de to flader er forskellige:

     - Paa telefon daekker kortet skaermen, og `position: fixed` paa body er
       den eneste laas iOS respekterer. Rulhoejden gemmes og gives tilbage
       ved lukning, ellers ville kunden lande i toppen af siden.
     - Paa desktop er skuffen et panel i hoejre side, og siden bagved er
       synlig. Der ville `position: fixed` flytte hele siden synligt, saa der
       bruges `overflow: hidden`, som holder rulhoejden af sig selv. Den
       forsvundne rullebjaelke kompenseres med padding, saa layoutet ikke
       skrider 15 px til hoejre. */
  var laastY = 0, erLaast = false, fastLaast = false;

  function erTelefon() { return window.matchMedia('(max-width: 768px)').matches; }

  function laasSiden() {
    if (erLaast) return;
    erLaast = true;
    var h = document.documentElement;
    /* To flader kan vaere aabne samtidig - arket, og kurven oven paa det - og
       kurven har sin egen laas i firmanumre-kurv.js. Uden en faelles taeller
       ville den anden laas laese `pageYOffset` som 0, fordi body allerede er
       fastlaast, og siden ville springe til toppen, naar den slap.
       Taelleren og den gemte rulhoejde deles derfor gennem html-elementet,
       som begge filer kan se. */
    var n = parseInt(h.getAttribute('data-fn-laast') || '0', 10);
    h.setAttribute('data-fn-laast', String(n + 1));
    if (n > 0) return;
    laastY = window.pageYOffset || h.scrollTop || 0;
    h.setAttribute('data-fn-laast-y', String(laastY));
    var b = document.body;
    var bjaelke = window.innerWidth - h.clientWidth;
    h.style.overflow = 'hidden';
    b.style.overflow = 'hidden';
    if (bjaelke > 0) b.style.paddingRight = bjaelke + 'px';
    if (erTelefon()) {
      fastLaast = true;
      b.style.position = 'fixed';
      b.style.top = (-laastY) + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
    }
  }

  function laasOp() {
    if (!erLaast) return;
    erLaast = false;
    var h = document.documentElement;
    var n = parseInt(h.getAttribute('data-fn-laast') || '1', 10) - 1;
    if (n > 0) { h.setAttribute('data-fn-laast', String(n)); return; }
    var y = parseInt(h.getAttribute('data-fn-laast-y') || '0', 10);
    h.removeAttribute('data-fn-laast');
    h.removeAttribute('data-fn-laast-y');
    var b = document.body;
    h.style.overflow = '';
    b.style.overflow = '';
    b.style.paddingRight = '';
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    fastLaast = false;
    window.scrollTo(0, y);
  }

  function opsaetLaas() {
    function aaben() { return document.body.classList.contains('js-drawer-open-right'); }
    if (aaben()) laasSiden();
    /* Temaet aabner og lukker skuffen ved at saette en klasse paa body. Der er
       ingen dokumenteret callback i Debutify, saa klassen aflaeses direkte.
       Laasen roerer ikke selv body's klasser, saa observeren udloeser ikke
       sig selv; og begge funktioner vender straks tilbage, naar tilstanden
       allerede er den rigtige. */
    new MutationObserver(function () {
      if (aaben()) laasSiden(); else laasOp();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- bevaegelse: raekker der kommer og gaar ---------- */

  function bevaegelseOk() {
    return window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  }

  /* Temaet tegner hele #CartContainer forfra ved enhver aendring, saa der er
     ingen raekke at animere "ind". Loesningen er at huske, hvilke numre der
     stod der sidst, og kun lade dem der ikke gjorde, flyve ind. Noeglen er
     produktets URL, som er stabil paa tvaers af gengivelser - linjenumrene
     forskyder sig, naar noget fjernes, og duer derfor ikke. */
  var kendteRaekker = null;

  function raekkeNoegle(p) {
    var a = p.querySelector('.fnkv-navn');
    return a ? (a.getAttribute('href') || a.textContent.trim()) : '';
  }

  function animerNye() {
    var raekker = document.querySelectorAll('#CartDrawer .ajaxcart__product');
    var nu = [], nye = [], i;
    for (i = 0; i < raekker.length; i++) {
      var k = raekkeNoegle(raekker[i]);
      nu.push(k);
      if (kendteRaekker && kendteRaekker.indexOf(k) === -1) nye.push(raekker[i]);
    }
    /* Der animeres kun, naar kortet FAKTISK er aabent. Skuffen tegnes ogsaa,
       mens den er lukket - foerst ved sideindlaesningen, senere ved hver
       aendring - og en indflyvning ingen kan se, er spildt arbejde, der
       ovenikoebet ville vaere brugt op, naar kortet saa blev aabnet.

       Foerste gengivelse springes over uanset hvad: da er der ikke tilfoejet
       noget, der er bare tegnet det, kurven allerede indeholdt. */
    var foerste = kendteRaekker === null;
    kendteRaekker = nu;
    if (foerste || !bevaegelseOk()) return;
    if (!document.body.classList.contains('js-drawer-open-right')) return;
    for (i = 0; i < nye.length; i++) {
      (function (el, n) {
        el.style.animationDelay = (n * 55) + 'ms';
        el.classList.add('fnkv-ind');
        el.addEventListener('animationend', function () {
          el.classList.remove('fnkv-ind');
          el.style.animationDelay = '';
        }, { once: true });
      })(nye[i], i);
    }
  }

  /* Taelleren i headeren.

     Temaets ajax-kurv skriver kun SYNLIGHEDEN paa boblen, ikke tallet. Maalt
     6. september: kurven gik fra 2 til 3 numre, mens boblen blev staaende paa
     2 indtil naeste sideindlaesning. Tallet skrives derfor herfra, ud fra
     serverens eget svar, hver gang kurven laeses.

     Boblen nikker, naar tallet gaar op. Kun opad - en fjernelse skal ikke
     fejres. */
  var sidsteTal = null;

  function opdaterTal(n) {
    if (typeof n !== 'number') return;
    var bobler = document.querySelectorAll('[data-fn-kurv-tal]');
    for (var i = 0; i < bobler.length; i++) {
      var b = bobler[i];
      if (b.textContent.trim() !== String(n)) b.textContent = String(n);
      if (n > 0) b.classList.add('cart-link__bubble--visible');
      else b.classList.remove('cart-link__bubble--visible');
      if (sidsteTal !== null && n > sidsteTal && bevaegelseOk()) {
        b.classList.remove('fnkv-puls');
        void b.offsetWidth;            // tvinger en ny animation, ogsaa to gange i traek
        b.classList.add('fnkv-puls');
      }
    }
    sidsteTal = n;
  }

  /* ---------- nummertypen over nummeret ---------- */

  /* Butikkens konvention er suffikset "(fastnet)" i produkttitlen. Handlebars
     kan ikke koere Liquid paa {{name}}, saa etiketten udledes her: staar der
     "(fastnet)", fjernes suffikset fra det viste navn og etiketten bliver
     "fastnet". Ellers "mobil". 70-numre baerer ogsaa suffikset og er altid
     fastnet, saa de falder rigtigt ud. */
  function saetType() {
    var linjer = document.querySelectorAll('#CartDrawer .fnkv-info');
    for (var i = 0; i < linjer.length; i++) {
      var info = linjer[i];
      var navn = info.querySelector('.fnkv-navn');
      var etiket = info.querySelector('.fnkv-type');
      if (!navn || !etiket) continue;
      /* Funktionen kaldes ved hver gengivelse. Uden denne vagt ville anden
         kaldsgang laese et navn, hvor suffikset allerede ER fjernet, og et
         fastnetnummer ville skifte etiket til "mobil". Maalt paa
         98 98 98 00 (fastnet), som stod som mobil. */
      if (info.dataset.fnkvType) continue;
      var tekst = navn.textContent.trim();
      var erFastnet = /\(fastnet\)/i.test(tekst);
      if (erFastnet) navn.textContent = tekst.replace(/\s*\(fastnet\)\s*/i, '').trim();
      /* Nummerkortet (SVG-skabelon + titel) skal ogsaa vise nummeret uden suffiks. */
      var linje = info.closest ? info.closest('.fnkv-linje') : null;
      var tal = linje ? linje.querySelector('.fn-nrkort__tal') : null;
      if (tal) tal.textContent = navn.textContent;
      etiket.textContent = erFastnet ? 'Fastnet' : 'Mobil';
      etiket.hidden = false;
      info.dataset.fnkvType = erFastnet ? 'fastnet' : 'mobil';
    }
  }

  /* ---------- kortet ---------- */

  function opsaetTraek() {
    var skuffe = document.getElementById('CartDrawer');
    if (!skuffe || skuffe.dataset.fnkvTraek === '1') return;
    if (!window.matchMedia('(max-width: 768px)').matches) return;
    skuffe.dataset.fnkvTraek = '1';

    var greb = skuffe.querySelector('.fnkv-greb');
    var hoved = skuffe.querySelector('.drawer__fixed-header');
    var startY = 0, sidsteY = 0, startTid = 0, aktiv = false, laast = false;
    var fraGreb = false, udfoldet = false;

    /* Der kan traekkes OVERALT i kortet, ikke kun i grebet. Konflikten med
       rulningen loeses paa retningen og paa hvor listen staar: en nedadgaaende
       bevaegelse bliver kun til et traek, naar `.drawer__inner` ligger i
       toppen. Er der rullet ned i numrene, ruller listen som normalt.

       Opad kan der kun foldes ud, naar fingeren tog fat i grebet eller
       hovedet - ellers ville et almindeligt rul opad i listen goere kortet
       hoejere. */
    function begynd(e) {
      if (e.touches.length !== 1) return;
      startY = e.touches[0].clientY;
      sidsteY = startY;
      startTid = Date.now();
      aktiv = true;
      laast = false;
      fraGreb = !!(e.target && e.target.closest &&
                   (e.target.closest('.fnkv-greb') || e.target.closest('.drawer__fixed-header')));
    }

    function flyt(e) {
      if (!aktiv) return;
      var y = e.touches[0].clientY;
      var d = y - startY;
      if (!laast) {
        if (Math.abs(d) < 6) return;
        var inder = skuffe.querySelector('.drawer__inner');
        var iTop = !inder || inder.scrollTop <= 0;
        if (d > 0 && iTop) { laast = true; skuffe.style.transition = 'none'; }
        else if (d < 0 && fraGreb) { laast = true; skuffe.style.transition = 'none'; }
        else { aktiv = false; return; }
      }
      e.preventDefault();
      sidsteY = y;
      var flyt_d = d;
      if (flyt_d < 0) flyt_d = udfoldet ? 0 : Math.max(flyt_d, -90);
      skuffe.style.transform = 'translateY(' + flyt_d + 'px)';
    }

    function slut() {
      if (!aktiv) return;
      aktiv = false;
      if (!laast) return;
      laast = false;
      skuffe.style.transition = '';
      skuffe.style.transform = '';
      var d = sidsteY - startY;
      var fart = d / Math.max(Date.now() - startTid, 1);
      if (d > 90 || (d > 40 && fart > 0.35)) {
        var luk = document.querySelector('#CartDrawer .js-drawer-close');
        if (luk) luk.click();
      } else if (d < -50 && fraGreb) {
        udfoldet = true;
        skuffe.style.height = '88dvh';
      }
    }

    skuffe.addEventListener('touchstart', begynd, { passive: true });
    skuffe.addEventListener('touchmove', flyt, { passive: false });
    skuffe.addEventListener('touchend', slut, { passive: true });
    skuffe.addEventListener('touchcancel', slut, { passive: true });
    if (greb) greb.style.touchAction = 'none';
    if (hoved) hoved.style.touchAction = 'none';
  }

  /* ---------- skraldespanden ---------- */

  /* Temaets handler paa `.ajaxcart__qty-adjust` laeser antallet fra et
     SOESKENDE `.ajaxcart__qty-num`. Skraldespanden staar i titelraekken og har
     ingen saadan soeskende, saa handleren kastede og knappen gjorde intet.
     I stedet saettes det skjulte felt til 0, og temaets egen `change`-lytter
     paa `.ajaxcart__qty-num` gengiver kurven. Ingen egen fjern-logik. */
  function opsaetFjern() {
    var knapper = document.querySelectorAll('#CartDrawer .fnkv-fjern');
    for (var i = 0; i < knapper.length; i++) {
      var k = knapper[i];
      if (k.dataset.fnkvBundet) continue;
      k.dataset.fnkvBundet = '1';
      k.addEventListener('click', function (e) {
        e.preventDefault();
        var raekke = this.closest('.ajaxcart__row');
        if (!raekke) return;
        var felt = raekke.querySelector('.ajaxcart__qty-num');
        if (!felt) return;
        function fjern() {
          felt.value = '0';
          felt.dispatchEvent(new Event('change', { bubbles: true }));
        }
        /* Raekken foldes sammen, FOER temaet faar besked. Uden det forsvinder
           nummeret i samme oejeblik der trykkes, og resten hopper op.
           Hoejden maales og saettes fast foerst - der kan ikke animeres fra
           `auto`. */
        var produkt = this.closest('.ajaxcart__product');
        if (!produkt || !bevaegelseOk()) { fjern(); return; }
        produkt.style.height = produkt.offsetHeight + 'px';
        void produkt.offsetHeight;
        produkt.classList.add('fnkv-ud');
        window.setTimeout(fjern, 260);
      });
    }
  }

  /* ---------- knappen laases af afkrydsningen ---------- */

  function opsaetVilkaar() {
    var boks = document.querySelector('#CartDrawer #agree');
    var knap = document.querySelector('#CartDrawer .cart__checkout');
    if (!knap) return;
    /* Er afkrydsningen skjult, maa knappen ikke vaere laast: kunden ville ikke
       kunne se hvorfor. Vises feltet igen, laaser den som foer. */
    var vist = boks && boks.offsetParent !== null;
    if (!boks || !vist) { knap.disabled = false; return; }
    function opdater() { knap.disabled = !boks.checked; }
    boks.addEventListener('change', opdater);
    opdater();
  }

  /* ---------- bind efter hver gengivelse af skuffen ---------- */

  function visUdloebsbesked() {
    var flag = null;
    try { flag = window.sessionStorage.getItem('fn_kurv_udloebet'); } catch (e) {}
    if (!flag) return;
    var p = document.querySelector('#CartDrawer .fnkv-udloebet');
    if (p) p.hidden = false;
    try { window.sessionStorage.removeItem('fn_kurv_udloebet'); } catch (e) {}
  }

  function bind() {
    saetType();
    animerNye();
    opsaetFjern();
    opsaetTraek();
    opsaetVilkaar();
    synkroniserFrist();        // bremsen i hentKurv sikrer et frisk, samlet svar
  }

  function start() {
    /* Uret startes uanset om skuffen findes. Fristen skal kunne udloebe paa en
       hvilken som helst side, ogsaa uden at kurven er aabnet. */
    synkroniserFrist();
    visUdloebsbesked();
    opsaetLaas();
    window.setInterval(function () { sidstSvar = 0; hentKurv(); }, 20000);

    var beholder = document.getElementById('CartContainer');
    if (!beholder) return;
    bind();
    // Temaets ajax-kurv tegner #CartContainer forfra ved hver aendring. En
    // observer er sikrere end at haenge paa temaets egne callbacks, som ikke
    // er dokumenterede i Debutify.
    /* Temaets gengivelse udloeser en stribe mutationer i traek, og et bind pr.
       mutation gav syv /cart.js-kald for én tilfoejelse. De samles i ét kald
       pr. gengivelse. */
    var venter = null;
    var obs = new MutationObserver(function () {
      if (venter) window.clearTimeout(venter);
      venter = window.setTimeout(function () { venter = null; bind(); }, 30);
    });
    obs.observe(beholder, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Kurvens indhold skal vaere kendt FOER kunden naar at trykke, ellers kan et
     nummer der allerede ligger i kurven, naa at blive lagt i igen. Kaldet er
     det samme debouncede hentKurv, saa det falder sammen med temaets egne. */
  hentKurv();

  window.fnKurv = {
    harVariant: function (id) { return !!iKurven[String(id)]; },
    hent: hentKurv
  };
})();
